import { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

/**
 * Retorna em tempo real todas as OS criadas pelo técnico logado.
 * Coleção: ordens/{osId}  (top-level, acessível também por supervisor/admin)
 */
export function useMinhasOS() {
  const [ordens,  setOrdens]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    const uid = getAuth().currentUser?.uid;
    if (!uid) {
      setOrdens([]);
      setLoading(false);
      return;
    }

    const db = getFirestore();
    const q  = query(
      collection(db, 'ordens'),
      where('tecnicoUid', '==', uid),
      orderBy('criadaEm', 'desc')
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        setOrdens(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('useMinhasOS:', err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  return { ordens, loading, error };
}
